// components/ScheduleTab.jsx
import React, { useState } from 'react';
import { Card, Button, Spin, Empty } from 'antd';
import { ScheduleOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import ScheduleList from './ScheduelList';
import ScheduleModal from '../Modals/SchedualModal';


const ScheduleTab = ({ 
  schedules, 
  loading, 
  onCreate, 
  onUpdate, 
  onDelete, 
  onRefresh 
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState(null);

  const handleCreateSchedule = () => {
    setEditingSchedule(null);
    setModalVisible(true);
  };

  const handleEditSchedule = (schedule) => {
    setEditingSchedule(schedule);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setEditingSchedule(null);
  };

  const handleScheduleSubmit = async (scheduleData) => {
    try {
      if (editingSchedule) {
        await onUpdate(editingSchedule.id, scheduleData);
      } else {
        await onCreate(scheduleData);
      }
      handleModalClose();
    } catch (error) {
      // Error handling is done in the hook
      console.error('Error submitting schedule:', error);
    }
  };

  return (
    <>
      <Card
        title={
          <div className="flex justify-between items-center">
            <span className="text-primary font-medium">
              <ScheduleOutlined className="mr-2" />
              Patient Schedules
            </span>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleCreateSchedule}
              className="bg-[#298d9f] hover:bg-[#206c7a]"
            >
              Add Schedule
            </Button>
          </div>
        }
        bordered={false}
        className="bg-[#f9fafa]"
      >
        <Spin spinning={loading}>
          {schedules.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <div className="text-center py-8">
                  <ScheduleOutlined className="text-4xl mb-2 block text-gray-400" />
                  <p className="text-gray-500">No schedules found for this patient</p>
                  <Button 
                    type="primary" 
                    onClick={handleCreateSchedule}
                    className="mt-2 bg-[#298d9f]"
                  >
                    Create First Schedule
                  </Button>
                </div>
              }
            />
          ) : (
            <ScheduleList
              schedules={schedules}
              onEdit={handleEditSchedule}
              onDelete={onDelete}
            />
          )}
        </Spin>
      </Card>

      <ScheduleModal
        visible={modalVisible}
        onClose={handleModalClose}
        onSubmit={handleScheduleSubmit}
        editingSchedule={editingSchedule}
        loading={loading}
      />
    </>
  );
};

ScheduleTab.propTypes = {
  schedules: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired
};

ScheduleTab.defaultProps = {
  loading: false
};

export default ScheduleTab;